<nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" *ngFor="let item of footerItems">
            <div [ngSwitch]="item.url">
              <div *ngSwitchCase="undefined">
                <a [class]="item.class" aria-current="page">{{ item.title }}</a>
              </div>
              <div *ngSwitchCase="''">
                <a [class]="item.class" aria-current="page" (click)="goNavigation(item.component)">{{ item.title }}</a>
              </div>
              <div *ngSwitchDefault>
                <a [class]="item.class" aria-current="page" [href]="item.url" target="_blank">{{ item.title }}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
</nav>